import ITEM_STATUS from '@/pages/dishes-for-br/consts/item/item-status'
import SOLD_STATUS from '@/pages/dishes-for-br/consts/item/sold-status'

export const adjustItemStatus = item => {
  // 注意：如果 soldStatus是售罄 把status置成下架
  // 这是一个延续下来的逻辑...
  if (item.soldStatus === SOLD_STATUS.SOLD_OUT) {
    item.status = ITEM_STATUS.OFF_SALE
  }
  return item
}
